import { Actions } from '../../interfaces'

import find from './find'
import { BusinessApproach } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { BusinessApproach },
  actions: { [BusinessApproach.name]: actions },
}
